import type { FeatureCollection } from 'geojson'
import { API } from '~/data/api'

export const useSectionService = () => {
  const interactionStore = useInteractionStore()

  async function getSection(id: number) {
    const response = await API?.getSection(id)

    if (response?.data) {
      interactionStore.initItem('sections', response.data.id, {
        likedByMe: response.data.liked_by_me,
        likeCount: response.data.likes_count,
        commentCount: response.data.comments_count
      })
    }

    return response?.data
  }

  async function getSectionGeoJSON(id: string) {
    const response = await API?.getSectionGeoJSON(id)
    return response?.data
  }

  async function getSectionPolyline(id: number) {
    const response = await API?.getSectionPolyline(id)

    return response?.data
  }

  async function getSectionLocations(id: number) {
    const response = await API?.getSectionLocations(id)
    return response?.data
  }

  async function getSectionWeather(id: string) {
    const response = await API?.getSectionWeather(id)
    return response?.data
  }

  async function updateTrip(
    id: string,
    data: {
      title: string
      note: string
      weather: any
      friend_ids: string[]
      hide_max_speed: boolean
      bike_id: string
      truncate_tails: boolean
      privacy: string
    }
  ) {
    return await API?.putTrip(id, data)
  }

  return {
    getSection,
    getSectionGeoJSON,
    getSectionPolyline,
    getSectionLocations,
    getSectionWeather,
    updateTrip
  }
}
